import Query from "./query";

class GetVolumePosition extends Query {
    constructor() {
        super('volume');
    }

    async executeChildQuery(branchId, options) {
        branchId = branchId.id ? branchId.id : branchId;
        const volumeBoundingBoxCenterPosition = new THREE.Vector3();
        const volumeWorldBoundingBox = new THREE.Box3();
        volumeWorldBoundingBox.copy(getCurrentBoundingBoxOfVolumesInWorld(branchId));
        volumeWorldBoundingBox.getCenter(volumeBoundingBoxCenterPosition);

        const rootObjectPosition = new THREE.Vector3();
        rootObjectPosition.setFromMatrixPosition(wv.rootObject.matrixWorld);

        const volumeWorldPosition = new THREE.Vector3().subVectors(volumeBoundingBoxCenterPosition, rootObjectPosition);
        return volumeWorldPosition.toArray();
    }
}

export default GetVolumePosition;
